export default "__VITE_ASSET__e47e8b78__"